import React from 'react';
import './App.scss';
import { CountdownSection } from './components/CountDown/CountdownSection';
import { OurStorySection } from './components/OurStorySection/OurStorySection';
import { ScheduleSection } from './components/ScheduleSection/ScheduleSection';
import { VenueSection } from './components/VenueSection/VenueSection';
import { AccommodationSection } from './components/AccommodationSection/AccommodationSection';
import { TransferSection } from './components/TransferSection/TransferSection';
import { ContactSection } from './components/ContactSection/ContactSection';
import { DressCodeSection } from './components/DressCodeSection/DressCodeSection';
import { Sparkles } from './components/Sparkles/Sparkles';
import { HeaderSection } from './components/HeaderSection/HeaderSection';
import { Navigation } from './components/NavigationComponent/Navigation';
import { ExtrasSection } from './components/ExtrasSection/ExtrasSection';
import { RsvpSection } from './components/RsvpSection/RsvpSection';

function App() {
  return (
    <div className="App">
      <Navigation />
      <Sparkles />
      <HeaderSection />
      <CountdownSection />
      <OurStorySection  />
      <ScheduleSection />
      <VenueSection />
      <AccommodationSection />
      <TransferSection />
      <DressCodeSection />
      <ExtrasSection />
      <RsvpSection />
      <ContactSection />
    </div>
  );
}

export default App;
 